export const iconFontAwesomeNumbers4 = (
	<i className="fa-solid fa-4"></i>
);
